import { ZealApiSuccessResponse } from "@zeal/common";

import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  IPatchDashboardCustomizationArgs,
  IPatchDashboardCustomizationResponseData,
} from "./patchDashboardCustomization.schema";

type SuccessResponse =
  ZealApiSuccessResponse<IPatchDashboardCustomizationResponseData>;

export const patchDashboardCustomization = (axios: IAxiosInstance) => {
  return async (params: IPatchDashboardCustomizationArgs) => {
    try {
      const response = await axios.noRetry.patch<SuccessResponse>(
        "/api/dashboard-customizations",
        params
      );
      return response?.data?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
